import { Outlet } from 'react-router-dom'
import { Toaster } from 'sonner'
import { useAuth } from '@/shared/lib/auth/auth-context'
import { PageMetaProvider } from '@/shared/lib/context/page-meta-context'
import { LoadingOverlay } from '@/shared/components/ui/loading-overlay'
import { FloatingAssistantPanel } from '@/features/assistant/components/floating-assistant-panel'
import { TopNav } from './top-nav'
import { SecondaryToolbar } from './secondary-toolbar'
import { DemoBanner } from './demo-banner'
import { AccessSuspendedDialog } from './access-suspended-dialog'

export function AppLayout() {
  const { isSwitchingTenant } = useAuth()

  return (
    <div className="h-screen flex flex-col bg-background">
      <PageMetaProvider>
        <TopNav />
        <SecondaryToolbar />
        <DemoBanner />
        <main className="flex-1 min-h-0 overflow-auto">
          <Outlet />
        </main>
        <FloatingAssistantPanel />
      </PageMetaProvider>
      <Toaster richColors position="top-right" />
      <LoadingOverlay show={isSwitchingTenant} />
      <AccessSuspendedDialog />
    </div>
  )
}
